import { getNumMonthsBetweenDates } from '../utils/dates';

export const getInterestOnlyTermMonths = (input: {
  interestOnlyTermMonths?: number | null;
  interestOnlyTermYears?: number | null;
  firstPaymentDate?: Date;
  interestOnlyEndDate?: Date;
}): number => {
  const endDateMonths =
    input.interestOnlyEndDate && input.firstPaymentDate
      ? getNumMonthsBetweenDates(input.firstPaymentDate, input.interestOnlyEndDate)
      : 0;
  return input.interestOnlyTermMonths || (input.interestOnlyTermYears ?? 0) * 12 || endDateMonths;
};
